import { Link } from "react-router-dom";
import Reveal from "../ui/Reveal";
import GetApp from "../ui/GetApp";
import { TRIAL_DAYS } from "../data/pricing";
import "./start-free.css";

/**
 * Where the price used to be on the home page: the free start instead.
 *
 * The owner's call (2026-10-15): at launch the home page sells the download,
 * not a plan, so it shows no rupee figure. A price before the owner has seen
 * their own members in the app is a reason to leave; the trial is a reason to
 * try. Prices still live on /pricing, one quiet link away, so nothing is
 * hidden from the reader who wants them (and Razorpay's site review needs that
 * page).
 *
 * The three steps answer what a trial actually asks of the owner, in the order
 * it happens, ending on the part people fear: what happens at the end. No
 * feature list here: the Everything section just above is that list, and
 * repeating it doubled this section's height on a phone, between the reader
 * and the button.
 *
 * Kept id="pricing" so links into /#pricing still land here.
 */
const STEPS = [
  {
    when: "Day 1",
    title: "Add your members",
    body: "From your phone, with their plan, dates and what they have paid. Ten minutes for the first few.",
  },
  {
    when: "Every day after",
    title: "Run the gym on it",
    body: "Record fees, mark attendance, send reminders from your own WhatsApp, hand out workout plans.",
  },
  {
    when: `Day ${TRIAL_DAYS}`,
    title: "Decide",
    body: "Keep going on a plan, or walk away. Your members and payments export to a file either way.",
  },
];

export default function StartFree() {
  return (
    <section className="section start-free" id="pricing">
      <div className="container container--wide">
        <div className="free__head">
          <Reveal>
            <h2 className="t-display-2 free__title">
              Free for {TRIAL_DAYS} days. No card.
            </h2>
          </Reveal>
          <Reveal delay={0.06}>
            <p className="t-lead free__lead">
              Try it on your real members, not a demo. Everything in the app is
              open in the trial except Auto reminders, which start when you
              subscribe.
            </p>
          </Reveal>
        </div>

        <ol className="free__steps">
          {STEPS.map((step, i) => (
            <Reveal as="li" delay={0.06 * i} className="free__step" key={step.title}>
              <span className="free__when">{step.when}</span>
              <h3 className="free__step-title">{step.title}</h3>
              <p className="free__step-body">{step.body}</p>
            </Reveal>
          ))}
        </ol>

        <div className="free__ask">
          <GetApp />
          <p className="t-sm t-dim free__plans">
            After the trial, every plan has every feature.{" "}
            <Link to="/pricing">See plans</Link>
          </p>
        </div>
      </div>
    </section>
  );
}
